import React from 'react';
// import css from './FolderTree.module.css';

import {
  TreeView,
  TreeItem,
} from '@material-ui/lab';
import SvgIcon from '@material-ui/core/SvgIcon';
import CircularProgress from '@material-ui/core/CircularProgress';
import { alpha, /*makeStyles,*/ withStyles } from '@material-ui/core/styles';


// Custom Styles
function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}

function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

const StyledTreeItem = withStyles((theme) => ({
  iconContainer: {
    '& .close': {
      opacity: 0.3,
    },
    '& .loading-spinner': {
      animation: '$spin 1s linear infinite',
    },
  },
  group: {
    marginLeft: 7,
    paddingLeft: 15,
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}))((props) => <TreeItem {...props} />);

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 400,
  },
});


class FolderTree extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      classes: props.classes,
      onInit: props.onInit,
      onSelect: props.onSelect,
      dummy: { name: "_", path: "_", children: []},
      expanded: [],
      selected: null,
      hash: {},
      loadingNodes: new Set(), // Track which nodes are loading
    };
  }

  componentDidMount() {
    this.reload();
    if(this.state.onInit)
      this.state.onInit({ reset: this.reset, hash: this.state.hash, reload: this.reload });
  }

  reset = () => {
    this.setState({ selected: null, expanded: [] });
  }

  reload = () => {
    try {
      this.setState({ selected: null });
      let hash = {};
      hash['/'] = { name: 'root', path: '/', children: [this.state.dummy], processed: false };
      hash['_'] = this.state.dummy;
      this.setState({ expanded: [], hash: hash });
    } catch (err) { console.log(err); };
  }

  getSubFolders = async (path='') => {
    return new Promise(async (resolve, reject) => {
      try {
        let params = new URLSearchParams({ path: path });
        let endpoint = `/api/folders?${params}`;
        let response = await fetch(endpoint);
        let result = await response.json();
        return resolve(result.folders);
      } catch (err) { reject(console.log(err)); }
    }
  )}

  updateChildren = async (hash, parent) => {
    if(parent.processed)
      return;
    parent.children.pop(); // Remove dummy child
    try {
      let subFolders = await this.getSubFolders(parent.path);
      for(let folder of subFolders) {
        let childPath = `${parent.path}${folder}/`
        let child = { name: folder, path: childPath,
          children: [hash['_']], processed: false };
        hash[child.path] = child;
        parent.children.push(child);
      }
      parent.processed = true
    } catch (err) { console.log(err); };
  }

  handleToggle = async (event, nodeIds) => {;
    let newHash = JSON.parse(JSON.stringify(this.state.hash));
    let newLoadingNodes = new Set(this.state.loadingNodes);
    
    for(let hashId of nodeIds) {
      if (!newHash[hashId]?.processed) {
        newLoadingNodes.add(hashId);
        this.setState({ loadingNodes: newLoadingNodes });
        await this.updateChildren(newHash, newHash[hashId]);
        newLoadingNodes.delete(hashId);
      }
    }
    
    this.setState({ expanded: nodeIds, hash: newHash, loadingNodes: newLoadingNodes });
  }

  handleSelect = (event, nodeId) => {
    this.setState({ selected: nodeId });
    this.state.onSelect(this.state.hash[nodeId].path.slice(1), nodeId, this.state.hash[nodeId].name);
  }

  renderTree = (hashId) => {
    const folder = this.state.hash[hashId];
    if(!folder)
      return null;
    
    const isLoading = this.state.loadingNodes.has(hashId);
    const icon = isLoading ? (
      <CircularProgress size={14} className="loading-spinner" />
    ) : undefined;
    
    return (
      <StyledTreeItem 
        key={folder.path} 
        nodeId={folder.path} 
        label={folder.name}
        collapseIcon={icon}
        expandIcon={icon}
      >
        {folder.children.map((child) => this.renderTree(child.path))}
      </StyledTreeItem>
    )
  }

  render() {
    return (
      <TreeView
          className={this.state.classes.root}
          defaultCollapseIcon={<MinusSquare />}
          defaultExpandIcon={<PlusSquare />}
          defaultEndIcon={<CloseSquare />}
          expanded={this.state.expanded}
          selected={this.state.selected}
          onNodeToggle={this.handleToggle}
          onNodeSelect={this.handleSelect}
        >
          {this.renderTree('/')}
        </TreeView>
    );
  }
}


FolderTree.defaultProps = {
};

// export default FolderTree;
export default withStyles(styles)(FolderTree);